import { Home, WifiOff } from 'lucide-react'
import { useNavigate } from 'react-router-dom'

import { Button } from '@/components/ui/button'

export function NotFound() {
  const navigate = useNavigate()

  return (
    <div className="flex h-screen flex-col items-center justify-center gap-6 p-4">
      <div className="flex flex-col items-center">
        <WifiOff className="mb-4 h-20 w-20 animate-pulse text-red-500" />
        <h2 className="text-center text-3xl font-semibold">
          Opa! Parece que você se perdeu...
        </h2>
        <p className="text-muted-foreground mt-2 max-w-md text-center">
          Não encontramos a página que você procura. Talvez ela tenha sido
          movida ou você esteja desconectado.
        </p>
      </div>

      <div className="text-6xl">😢</div>

      <Button onClick={() => navigate('/')} className="flex items-center gap-2">
        <Home className="h-4 w-4" />
        Voltar para a página inicial
      </Button>
    </div>
  )
}
